export default class Sound{
    static Success(){
        let sound = require('@/assets/addcart2-almedio.mp3')
        var audio = new Audio(sound);
        audio.play();
        return true
    }
}